import React from 'react';
import { Button, Divider } from '@cad-arc';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { FrBoloPageFooter } from '../fr-bolos-page/components/fr-bolo-page-footer';
import { useBoloPanelMetadata } from '../bolos/bolo-panel/state/bolo-panel-metadata-context';
import { AttachmentsPreview } from '../attachments/attachments-preview';
import { FR_BOLO_ROOT_PATH, EVENTS_WINDOW_PATH } from '../router/constants';
import { AttachmentSortOptionValue } from '../attachments/types';
import { DEFAULT_ATTACHMENT_SORT_OPTION_VALUE } from '../attachments/constants';
import { FrAttachmentsPageLayout } from '../attachments/fr-attachments-page-layout';

export function FrBoloAttachmentsPage() {
    const { boloId, attachmentId } = useParams<{ boloId: string; attachmentId: string }>();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const boloMetadata = useBoloPanelMetadata();

    const sortOption =
        (searchParams.get('sortOption') as AttachmentSortOptionValue) ||
        DEFAULT_ATTACHMENT_SORT_OPTION_VALUE;

    const handleGoBack = () => {
        navigate(`${FR_BOLO_ROOT_PATH}/${boloId}`, {
            state: {
                activeTab: 'MEDIA_ATTACHMENTS',
                previousLocationPathname: EVENTS_WINDOW_PATH,
            },
        });
    };
    return (
        <FrAttachmentsPageLayout footer={<FrBoloPageFooter />}>
            <Button variant="outline" leadingVisual="ArrowLeft" onClick={handleGoBack}>
                Back to BOLO Attachments
            </Button>
            {boloId && (
                <>
                    <Divider />
                    <AttachmentsPreview
                        entityId={boloId}
                        entityType="BOLO"
                        entityNumber={boloMetadata?.boloNumber}
                        attachmentId={attachmentId ? Number(attachmentId) : undefined}
                        sortOption={sortOption}
                    />
                </>
            )}
        </FrAttachmentsPageLayout>
    );
}
